import { getAppStore } from '../../app/AppStore';
import { Module } from '../Module';

interface IAppAdminStateScope extends ng.IScope {
  displayDefault: boolean;
  displayInnerApp: boolean;
}

Module.instance().directive('tbApp', [
  () => {
    return ({
      restrict: 'E',
      replace: true,
      template: `
        <div class="tb-app-inner">
          <div ng-if="displayInnerApp">
            <tb:app-inner/>
          </div>
          <div ng-if="displayDefault">
            <tb:root-space-router />
          </div>
          <div ng-if="displayDefault">
            <tb:navigation-telemetry />
          </div>
        </div>
      `,
      scope: {},
      link: (scope: IAppAdminStateScope) => {
        function updateDisplayDefault() {
          const rootAdminUiState = getAppStore().getState().rootAdminUiState;
          scope.displayDefault = rootAdminUiState === 'default';
          scope.displayInnerApp = rootAdminUiState !== 'default' && rootAdminUiState !== 'bootstrap';
        }
        updateDisplayDefault();
        getAppStore().subscribe(() => {
          updateDisplayDefault();
        });
      }
    });
  }
]);
